import { z } from 'zod';
const permissionSchema = z.enum(['plan', 'reserve', 'cancel', 'view_finance']);
export const canteenDelegationSchema = z.object({
    id: z.string().uuid(),
    principalAccountId: z.string().uuid(),
    principalPersonId: z.string().uuid(),
    principalDisplayName: z.string().min(1),
    audience: z.object({
        personIds: z.array(z.string().uuid()),
        groupIds: z.array(z.string().uuid()),
        includeNestedGroups: z.boolean(),
    }),
    dependents: z.array(z.object({ personId: z.string().uuid(), displayName: z.string().min(1) })),
    permissions: z.array(permissionSchema).min(1),
    validFrom: z.string().datetime({ offset: true }),
    validUntil: z.string().datetime({ offset: true }).nullable(),
    reason: z.string().min(3),
    state: z.enum(['active', 'revoked', 'expired']),
    createdAt: z.string().datetime({ offset: true }),
});
export const createCanteenDelegationAdminSchema = z
    .object({
    principalAccountId: z.string().uuid(),
    audience: z.object({
        mode: z.enum(['people', 'groups']),
        personIds: z.array(z.string().uuid()).default([]),
        groupIds: z.array(z.string().uuid()).default([]),
        includeNestedGroups: z.boolean().default(true),
        requiredProfileType: z
            .literal('meal_recipient')
            .default('meal_recipient'),
    }),
    permissions: z
        .array(permissionSchema)
        .min(1)
        .default(['plan', 'reserve', 'cancel']),
    validFrom: z.string().datetime({ offset: true }).optional(),
    validUntil: z.string().datetime({ offset: true }).nullable().default(null),
    reason: z.string().trim().min(3).max(500),
})
    .superRefine((value, context) => {
    if (value.audience.mode === 'people' &&
        value.audience.personIds.length === 0)
        context.addIssue({
            code: 'custom',
            path: ['audience', 'personIds'],
            message: 'Wybierz co najmniej jedną osobę.',
        });
    if (value.audience.mode === 'groups' &&
        value.audience.groupIds.length === 0)
        context.addIssue({
            code: 'custom',
            path: ['audience', 'groupIds'],
            message: 'Wybierz co najmniej jedną grupę.',
        });
    if (value.validFrom &&
        value.validUntil &&
        new Date(value.validUntil) <= new Date(value.validFrom))
        context.addIssue({
            code: 'custom',
            path: ['validUntil'],
            message: 'Koniec delegacji musi być późniejszy od początku.',
        });
});
export const canteenDependentSchema = z.object({
    personId: z.string().uuid(),
    displayName: z.string().min(1),
    permissions: z.array(permissionSchema),
    delegationIds: z.array(z.string().uuid()),
});
